export const SECTION_DESIGN_COMMIT_INTERVAL_SECONDS = 10;
export const LAYER_DATE_INFO_INTERVAL_SECONDS = 5;
export const LAYERTAB_PROGRESS_INFO_INTERVAL_SECONDS = 5;